module.exports = __webpack_public_path__ + "assets/img/logo-wide.b8ae37f3.png";